// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3d703d49","453":"9382a1a0","455":"3fe61fe0","977":"0c8c2ab5"}[chunkId] + ".chunk.js";
};